<script setup lang="ts">
import { breakpointsBootstrapV5, useBreakpoints } from "@vueuse/core";
import { isNullish } from "@tinyurldev/tu-ui-vue";

import TeamsLayout from "@Modules/teams/Views/TeamsLayout.vue"
import OrgSettingsSidebar from "@Modules/teams/components/OrgSettingsSidebar.vue"
import PermissionDenied from "@Modules/teams/components/PermissionDenied.vue"
import type { Organization } from "@Modules/teams/Data/Models/OrganizationModel.ts"
import type { Team } from "@Modules/teams/Data/Models/TeamModel.ts"

//
// Props
interface Props {
    organization: Organization | null
    workspace?: Team | null
    can?: boolean
}

withDefaults(defineProps<Props>(), {
    workspace: null,
    can: true,
})

const breakpoints = useBreakpoints(breakpointsBootstrapV5);
const isMobileView = breakpoints.smallerOrEqual("xl");

</script>

<template>
  <TeamsLayout
    :organization="organization"
    :workspace="workspace"
    :can="!isNullish(organization)"
  >
    <section
      class="org-settings-layout"
      :class="{ 'org-settings-layout--mobile': isMobileView }"
    >
      <div
        v-if="!isMobileView && !isNullish(organization)"
        class="org-settings-layout__sidebar"
      >
        <OrgSettingsSidebar :org="organization" />
      </div>
      <div class="org-settings-layout__content">
        <template v-if="can">
          <slot />
        </template>
        <PermissionDenied v-else />
      </div>
    </section>
  </TeamsLayout>
</template>

<style lang="scss" scoped>
@use "@tinyurldev/tu-ui-vue/scss/settings/colors.scss" as color;
@use "@tinyurldev/tu-ui-vue/scss/settings/spacing.scss" as spacing;

.org-settings-layout {
  $self: &;

  display: flex;
  height: 100%;

  &__sidebar {
    width: 260px;
    background-color: color.$background-alternative;
    overflow-y: auto;
  }

  &__content {
    flex: 1;
    padding: spacing.$l;

    background-color: color.$background-primary;
    overflow-y: auto;
  }

  &--mobile {
    #{ $self }__content {
      padding: spacing.$l spacing.$xs;
    }
  }
}
</style>
